import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { CreateResellerCommand } from '../../../../core/api/models/create-reseller-command';
import { ResellerDto } from '../../../../core/api/models/reseller-dto';
import { UpdateResellerCommand } from '../../../../core/api/models/update-reseller-command';
import { ResellersService } from '../../../../core/api/services/resellers.service';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-resellers-form',
    templateUrl: './resellers-form.component.html',
    imports: [BaseFormModule]
})
export class ResellersFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<ResellerDto> = {};
  model: CreateResellerCommand = {};
  protected currentService = inject(ResellersService);

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.disableControls();
  }

  initForm() {
    this.form = new FormGroup({
      userId: new FormControl('', Validators.required),
      organizationId: new FormControl('', Validators.required),
      pricePerSms: new FormControl('', Validators.required),
      panelPercent: new FormControl('', [
        Validators.required,
        Validators.pattern(RegularExpressions.floatNumbers),
      ]),
      expireDate: new FormControl('', Validators.required),
      target: new FormControl(''),
    });
  }

  initModel(): void {
    try {
      if (this.formPageConfig.isEditMode)
        this.model = Object.assign({}, this.formPageConfig.editData);
      else {
        this.model.expireDate = DateTimeService.getAYearLater();
        this.formPageConfig.editData = {};
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  disableControls() {
    if (this.formPageConfig.isEditMode) {
      this.form.get('organizationId').disable();
      this.form.get('userId').disable();
    }
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateResellerCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .resellersCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateResellerCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .resellersUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    this.model.expireDate = DateTimeService.toUTC(this.model?.expireDate);
    super.onSubmit();
  }
}
